import React from 'react';
import { Button, Form, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRY_THEN_BUY_FRAUD } from '../../../../constants/define/translation';

interface FormThresholdProps {
  onSubmit: (value: string) => void;
  content: string;
  placeholder: string;
}
export const FormThreshold = (props: FormThresholdProps) => {
  const [form] = Form.useForm();
  const { onSubmit, content, placeholder } = props;
  const { t } = useTranslation(TRY_THEN_BUY_FRAUD);
  const defaultValue = { content };

  return (
    <>
      <Form form={form} initialValues={defaultValue} onFinish={onSubmit}>
        <div className="form-content pt-4 pb-2">
          <Form.Item
            name="content"
            label={t('setting.popup.label')}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            rules={[{ required: true, message: t('validate.field') }]}
          >
            <InputNumber placeholder={placeholder} min={1} />
          </Form.Item>
          <div className="mt-2">
            <Form.Item shouldUpdate>
              {() => (
                <div className="d-flex justify-content-end">
                  <Button
                    type="primary"
                    size="large"
                    id="btnSubmitInput"
                    className="px-4 btn mt-3"
                    htmlType="submit"
                    disabled={
                      !form.getFieldValue('content') ||
                      !!form.getFieldsError().filter(({ errors }) => errors.length).length
                    }
                  >
                    {t('form.submit')}
                  </Button>
                </div>
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};
